import React from 'react';

export type MoodValue = 'rough' | 'low' | 'okay' | 'good' | 'great';

interface MoodOption {
  value: MoodValue;
  emoji: string;
  label: string;
}

export const MOODS: readonly MoodOption[] = [
  { value: 'rough', emoji: '😢', label: 'Rough' },
  { value: 'low', emoji: '😔', label: 'Low' },
  { value: 'okay', emoji: '😐', label: 'Okay' },
  { value: 'good', emoji: '🙂', label: 'Good' },
  { value: 'great', emoji: '😊', label: 'Great' },
];


export interface MoodPickerProps {
  value: MoodValue | null;
  onChange: (mood: MoodValue) => void;
  label?: string;
  className?: string;
}

export function MoodPicker({
  value,
  onChange,
  label = 'How are you feeling?',
  className,
}: MoodPickerProps) {
  return (
    <div className={className}>
      {label && (
        <div className="text-xs font-semibold uppercase tracking-[0.05em] text-text-tertiary mb-3">
          {label}
        </div>
      )}
      <div className="flex justify-between">
        {MOODS.map((mood) => {
          const isActive = value === mood.value;
          return (
            <button
              key={mood.value}
              type="button"
              onClick={() => onChange(mood.value)}
              aria-pressed={isActive}
              aria-label={mood.label}
              className={[
                'w-14 h-12 rounded-[10px] border flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all min-h-[44px]',
                isActive
                  ? 'border-[var(--theme-success)] bg-[rgba(95,184,141,0.08)]'
                  : 'border-[var(--theme-border-light)] bg-transparent',
              ].join(' ')}
            >
              <span className="text-xl" aria-hidden="true">
                {mood.emoji}
              </span>
              <span className="text-[10px] text-text-tertiary">{mood.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
